<!-- src/components/Home.vue (ou src/views/Home.vue) -->
<template>
  <v-container fluid class="grey lighten-1">
    <!-- Cabeçalho -->
    <v-row align="center" class="mb-2">
      <v-col cols="12" md="7">
        <div class="text-h5 font-weight-bold">Indicadores por Colaborador</div>
        <div class="text-caption">
          Previstas, Esperadas e Trabalhadas do período selecionado.
        </div>
      </v-col>

      <v-col cols="12" md="5" class="d-flex justify-end flex-wrap" style="gap: 8px;">
        <v-btn color="primary" :loading="loading" @click="fetchRelatorio" small>
          <v-icon left>mdi-refresh</v-icon>
          Atualizar
        </v-btn>
      </v-col>
    </v-row>

    <!-- Filtros mínimos (período) -->
    <v-card outlined class="mb-4">
      <v-card-text class="py-3">
        <v-row dense align="center">
          <v-col cols="12" sm="3">
            <v-select
            v-model="filtros.mes"
            :items="meses"
            item-text="text"
            item-value="value"
            label="Mês"
            outlined
            dense
            :disabled="loading"
            @change="fetchRelatorio"
            />
          </v-col>

          <v-col cols="12" sm="2">
            <v-text-field
            v-model.number="filtros.ano"
            label="Ano"
            type="number"
            outlined
            dense
            :disabled="loading"
            @keyup.enter="fetchRelatorio"
            />
          </v-col>

          <v-col cols="12" sm="4">
            <v-text-field
            v-model="search"
            label="Buscar colaborador"
            outlined
            dense
            clearable
            :disabled="loading"
            prepend-inner-icon="mdi-magnify"
            />
          </v-col>

          <v-col cols="12" sm="3" class="d-flex justify-end">
            <v-chip small outlined>
              {{ colaboradoresFiltrados.length }} colaborador(es)
            </v-chip>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <!-- Cards por colaborador -->
    <v-row dense>
      <v-col v-for="col in colaboradoresFiltrados" :key="col.idfuncionarios || col.nome" cols="12" md="6" lg="4">
        <v-card outlined class="pa-1">
          <div class="card-head">
            <div class="card-title">
              <div class="text-subtitle-1 font-weight-bold grey--text text--darken-1">
                {{ col.nome }}
                <v-tooltip bottom v-if="isEmFeriasHoje(col)">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                    v-bind="attrs"
                    v-on="on"
                    small
                    class="ml-2 ferias-icon"
                    color="purple darken-2"
                    >
                    mdi-beach
                  </v-icon>
                </template>
                <span>Em férias hoje</span>
              </v-tooltip>
            </div>
            <div class="text-caption grey--text">
              ID {{ col.idfuncionarios }} • {{ periodoLabel }}
            </div>
          </div>

          <div class="card-bank">
            <div class="bank-value" :class="bankColorClass(col.bancoTotal)">
              {{ decimalParaHHmm(col.bancoTotal) }}
            </div>
            <div class="text-caption grey--text">
              Banco total
            </div>
          </div>
        </div>

        <v-divider class="mb-1" />

        <v-row class="mt-2">
          <v-col cols="12" sm="3">
            <div class="metric-wrapper">
              <div class="metric-label">Previstas</div>
              <div class="metric-value primary--text">
                {{ col.horasPrevistas }}
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="3">
            <div class="metric-wrapper">
              <div class="metric-label">Esperadas</div>
              <div class="metric-value indigo--text">
                {{ col.horasEsperadas }}
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="3">
            <div class="metric-wrapper">
              <div class="metric-label">Trabalhadas</div>
              <div class="metric-value success--text">
                {{ col.horasTrabalhadas }}
              </div>
            </div>
          </v-col>

          <v-col cols="12" sm="3">
            <div class="metric-wrapper">
              <div class="metric-label">Saldo mês</div>
              <div
              class="metric-value"
              :class="col.saldoBanco && col.saldoBanco.startsWith('-') ? 'error--text' : 'success--text'"
              >
              {{ col.saldoBanco }}
            </div>
          </div>
        </v-col>
      </v-row>

    </v-card>
  </v-col>

  <!-- Empty state -->
  <v-col v-if="!loading && colaboradoresFiltrados.length === 0" cols="12">
    <v-card outlined class="pa-8 text-center">
      <div class="text-subtitle-1 font-weight-medium">Nenhum dado para exibir</div>
      <div class="text-caption grey--text mt-1">
        Tente outro mês/ano ou limpe a busca.
      </div>
    </v-card>
  </v-col>
</v-row>

<!-- Snackbar -->
<v-snackbar v-model="snack.show" :color="snack.color" top right timeout="4000">
  {{ snack.text }}
  <template v-slot:action="{ attrs }">
    <v-btn text v-bind="attrs" @click="snack.show = false">Fechar</v-btn>
  </template>
</v-snackbar>
</v-container>
</template>

<script>
import axios from 'axios'
import { baseApiUrl, showError } from '@/global'

export default {
  name: 'TheHome',

  components: {

  },

  data() {
    const now = new Date()
    return {
      loading: false,
      search: '',
      filtros: {
        mes: now.getMonth() + 1,
        ano: now.getFullYear(),
      },
      meses: [
        { text: 'Janeiro', value: 1 },
        { text: 'Fevereiro', value: 2 },
        { text: 'Março', value: 3 },
        { text: 'Abril', value: 4 },
        { text: 'Maio', value: 5 },
        { text: 'Junho', value: 6 },
        { text: 'Julho', value: 7 },
        { text: 'Agosto', value: 8 },
        { text: 'Setembro', value: 9 },
        { text: 'Outubro', value: 10 },
        { text: 'Novembro', value: 11 },
        { text: 'Dezembro', value: 12 },
        ],
      // formato interno para os cards
      colaboradores: [],
      snack: { show: false, text: '', color: 'error' },
    }
  },

  computed: {
    periodoLabel() {
      const m = this.meses.find((x) => x.value === this.filtros.mes)?.text || String(this.filtros.mes)
      return `${m}/${this.filtros.ano}`
    },

    colaboradoresFiltrados() {
      const q = (this.search || '').trim().toLowerCase()
      if (!q) return this.colaboradores
        return this.colaboradores.filter((c) => String(c.nome || '').toLowerCase().includes(q))
    },
  },

  mounted() {
    this.fetchRelatorio()
  },

  methods: {
    toast(text, color = 'error') {
      this.snack.text = text
      this.snack.color = color
      this.snack.show = true
    },

    isUsuarioAtivo(item = {}) {
      const status = item.usuario_status ?? item.status_usuario ?? item.status ?? item.ativo

      // Se o backend antigo ainda não devolver status, não bloqueia no frontend.
      // O filtro principal fica no backend via /relatorios?status=ativos.
      if (status === undefined || status === null || status === '') return true

        return status === true ||
      status === 1 ||
      status === '1' ||
      String(status).trim().toLowerCase() === 'ativo'
    },

    // Aqui a gente "puxa do relatório" e mapeia:
    // - Horas Previstas  -> horasEsperadasBrutas
    // - Horas Esperadas  -> horasEsperadas
    // - Horas Trabalhadas-> totalHorasTrabalhadas
    async fetchRelatorio() {
      this.loading = true
      try {
        const params = {
          mes: this.filtros.mes,
          ano: this.filtros.ano
        }

        const { data } = await axios.get(`${baseApiUrl}/bancohoras/relatorio/geral`, { params })
        const arr = Array.isArray(data) ? data : []

        this.colaboradores = arr
        .map((r) => ({
          idfuncionarios: r.idfuncionarios,
          nome: r.nome,
          horasPrevistas: this.minutosParaHHmm(r.minutosPrevistos),
          horasEsperadas: this.minutosParaHHmm(r.minutosEsperados),
          horasTrabalhadas: this.minutosParaHHmm(r.minutosTrabalhados),

          saldoBanco: this.minutosParaHHmm(r.variacaoRelatorioMinutos),
          statusBanco: r.statusBanco || (String(r.bancoHoras || '').startsWith('-') ? 'Débito' : 'Crédito'),
          bancoTotal: Number(r.saldo || 0),
          statusBancoCorrigido: Number(r.variacaoRelatorioMinutos || 0) < 0 ? 'Debito' : 'Credito',
          statusBancoTotalCorrigido: Number(r.saldo || 0) < 0 ? 'Debito' : 'Credito',
          statusBancoTotal: r.statusBancoTotal || (String(r.bancoHorasTotal || '').startsWith('-') ? 'Débito' : 'Crédito'),
          expedientes: Array.isArray(r.expedientes) ? r.expedientes : [],
        }))

      } catch (e) {
        showError(e)
        this.toast('Falha ao carregar indicadores do relatório.')
        this.colaboradores = []
      } finally {
        this.loading = false
      }
    },
    minutosParaHHmm(valor) {
      const total = Number(valor || 0)
      const negativo = total < 0
      const abs = Math.abs(Math.trunc(total))
      const horas = Math.floor(abs / 60)
      const minutos = abs % 60

      return `${negativo ? '-' : ''}${String(horas).padStart(2, '0')}:${String(minutos).padStart(2, '0')}`
    },
    decimalParaHHmm(valor) {
      if (valor === null || valor === undefined) return '00:00'

        const n = Number(valor)
      if (isNaN(n)) return '00:00'

        const negativo = n < 0
      const abs = Math.abs(n)

      const horas = Math.floor(abs)
      const minutos = Math.round((abs - horas) * 60)

      const hh = String(horas).padStart(2, '0')
      const mm = String(minutos).padStart(2, '0')

      return `${negativo ? '-' : ''}${hh}:${mm}`
    },

    bankColorClass(valor) {
      const n = Number(valor)
      if (isNaN(n) || n === 0) return 'grey--text text--darken-1'
        return n > 0 ? 'orange--text text--darken-2' : 'error--text'
    },
    todayKey() {
      const d = new Date()
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`   
    },

    isEmFeriasHoje(col) {
      const hoje = this.todayKey()
      return (col.expedientes || []).some(e => e && e.data === hoje && e.ferias === true)
    },

  },
}
</script>

<style scoped>
/* Estilo neutro/profissional (sem cores gritantes) */
.metric-wrapper {
  padding: 6px 2px;
}

.metric-label {
  font-size: 60%;
  font-weight: normal;
  letter-spacing: 0.1px;
  text-transform: lowercase;
  color: #757575;
}

.metric-value {
  font-size: 0.8rem;
  font-weight: 700;
  margin-top: 2px;
}

.metric-sub {
  margin-top: 2px;
}

.card-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.card-title {
  min-width: 0;
}

.card-bank {
  text-align: right;
  white-space: nowrap;
}

.bank-value {
  font-size: 1.15rem;
  font-weight: 800;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
}

</style>
